module.exports = __webpack_public_path__ + "static/7-4cbf8193ae1d76c53577c26336c17ae7.jpg";